export function getTabStyle(
  index: number,
  customBtnId: any,
): { width: number; left: number } {
  const style = { width: 0, left: 0 };
  const _customBtnId = customBtnId || '';
  const tabNode = document.querySelector(`#tab_label_${index}${_customBtnId}`);

  try {
    if (!tabNode) return style;
    if (tabNode instanceof HTMLElement) {
      const tabWrapNode = document.querySelector(`#tab_btn_wrap${_customBtnId}`);
      if (!tabWrapNode) return style;

      const tabStyle = window.getComputedStyle(tabNode);
      style.width = parseFloat(tabStyle.width);

      // 부모 컨테이너를 기준으로 한 상대적 위치 계산
      const tabRect = tabNode.getBoundingClientRect();
      const wrapRect = tabWrapNode.getBoundingClientRect();

      // 스크롤 offset 고려
      const scrollLeft = tabWrapNode.scrollLeft || 0;

      // 탭 래퍼를 기준으로 한 상대적 위치 계산
      style.left = tabRect.left - wrapRect.left + scrollLeft;

      // 음수 값 방지
      if (style.left < 0) style.left = 0;
      if (style.width < 0) style.width = 0;

      return style;
    } else {
      return { left: 0, width: 0 };
    }
  } catch (err) {
    console.error('getTabStyle error:', err);
    return style;
  }
}

// 안정성을 위한 위치 재계산 함수
export function recalculateTabPosition(
  index: number,
  customBtnId: any,
  maxRetries: number = 3,
): Promise<{ width: number; left: number }> {
  return new Promise((resolve) => {
    let retries = 0;

    const calculate = () => {
      const style = getTabStyle(index, customBtnId);

      if (style.width > 0 || retries >= maxRetries) {
        resolve(style);
      } else {
        retries++;
        setTimeout(calculate, 50);
      }
    };

    calculate();
  });
}

// 디버깅용 함수
export function debugTabPosition(index: number, customBtnId: any) {
  const _customBtnId = customBtnId || '';
  const tabNode = document.querySelector(`#tab_label_${index}${_customBtnId}`);
  const tabWrapNode = document.querySelector(`#tab_btn_wrap${_customBtnId}`);

  console.log('Debug Tab Position:', {
    index,
    customBtnId: _customBtnId,
    tabNodeExists: !!tabNode,
    tabWrapNodeExists: !!tabWrapNode,
    tabRect: tabNode?.getBoundingClientRect(),
    wrapRect: tabWrapNode?.getBoundingClientRect(),
    scrollLeft: tabWrapNode?.scrollLeft,
    calculatedStyle: getTabStyle(index, customBtnId),
  });
}

// 백업용 기존 방식 (필요시 사용)
export function getTabStyleLegacy(
  index: number,
  customBtnId: any,
): { width: number; left: number } {
  const style = { width: 0, left: 0 };
  const _customBtnId = customBtnId || '';
  const tabNode = document.querySelector(`#tab_label_${index}${_customBtnId}`);

  try {
    if (!tabNode) return style;
    if (tabNode instanceof HTMLElement) {
      const tabStyle = window.getComputedStyle(tabNode);
      style.width = parseFloat(tabStyle.width);

      const firstTabLeftDistance: number = document
        .querySelector(`#tab_label_0${_customBtnId}`)!
        .getBoundingClientRect().left;

      const distanceMenuBoxToLeft: number = document
        .querySelector(`#tab_btn_wrap${_customBtnId}`)!
        .getBoundingClientRect().left;
      const startTargetLeft: number =
        firstTabLeftDistance - distanceMenuBoxToLeft;

      style.left = startTargetLeft;

      /* 좌측 탭의 width를 left로 가산 - customBtnId 포함 수정 */
      for (let i = 0; i < index; i++) {
        const leftTabNode = document.querySelector(`#tab_label_${i}${_customBtnId}`);
        if (leftTabNode) {
          const leftTabStyle = window.getComputedStyle(leftTabNode);
          style.left += 8; /* 탭 사이 margin값 */
          style.left += parseFloat(leftTabStyle.width);
        }
      }

      return style;
    } else {
      return { left: 0, width: 0 };
    }
  } catch (err) {
    console.error('getTabStyleLegacy error:', err);
    return style;
  }
}

export function getTabVerticalStyle(index: number): {
  height: number;
  top: number;
} {
  const style = { height: 0, top: 0 };
  try {
    const tabNode = document.querySelector(`#tab_label_${index}`);

    if (!tabNode) return style;

    const tabStyle = window.getComputedStyle(tabNode!);
    style.height = parseFloat(tabStyle.height);

    /* 좌측 탭의 width를 left로 가산 */
    for (let i = 0; i < index; i++) {
      const topTabNode = document.querySelector(`#tab_label_${i}`);
      const topTabStyle = window.getComputedStyle(topTabNode!);
      style.top += 0; /* 탭 사이 margin값 */
      style.top += parseFloat(topTabStyle.height);
    }

    return style;
  } catch (err) {
    return style;
  }
}

export function getTabScroll(index: number, customBtnId: any) {
  const tabWrapNode = document.querySelector(`#tab_btn_wrap`);
  const tabNode = document.querySelector(`#tab_label_${index}${customBtnId}`);

  if (!tabWrapNode && !tabNode) return;

  const tabStyle = window.getComputedStyle(tabWrapNode!);
  const tabWrapWidth = parseFloat(tabStyle.width);
  const { width, left } = getTabStyle(index, customBtnId);
  const tabStart = 16; /* 브라우저 left와 탭 사이 간격 */
  const tabMoreThanHalf = tabWrapWidth / 2 < left - tabStart;

  const scrollCenterDistance = tabWrapWidth / 2 - width / 2;

  if (tabMoreThanHalf) {
    tabWrapNode!.scrollLeft = scrollCenterDistance;
  }
  if (!tabMoreThanHalf) tabWrapNode!.scrollLeft = 0;
}

export function getMaskType(
  index: number,
  scrollLeft: number,
): 'right' | 'left' | 'center' | '' {
  const status = 'center';
  const tabWrapNode = document.querySelector(`#tab_btn_wrap`);
  8;
  if (!tabWrapNode) return status;

  const tabWrapScrollWidth =
    tabWrapNode!.scrollWidth - tabWrapNode!.clientWidth;

  if (tabWrapScrollWidth === 0) return '';

  if (index === 0 && scrollLeft === 0) {
    const status = 'right';
    return status;
  }
  if (scrollLeft === tabWrapScrollWidth) {
    const status = 'left';
    return status;
  }
  return status;
}
